// The message boxes' drafts, kept when a chat is left (15, Drafts), and over a round trip to desyr ID's
// page and back (36, Behaviour 1.4, v1.58.68: typed text stays as the draft).
import type { MatrixEvent } from 'matrix-js-sdk';
import type { Line } from './content';

export interface Draft {
  lines: Line[];
  reply?: MatrixEvent;
}
export const drafts = new Map<string, Draft>();

const KEPT = 'desyr_drafts_kept';
/** The open boxes' text as typed now, by their draft key. */
const open = new Map<string, () => Line[]>();
export const followDraft = (key: string, lines: () => Line[]) => (open.set(key, lines), () => void open.delete(key));

/** Before the page goes away for a round trip: every draft's text, the open boxes' too, kept for this tab. */
export function keepDrafts(): void {
  const all: Record<string, Line[]> = {};
  for (const [key, d] of drafts) all[key] = d.lines;
  for (const [key, lines] of open) all[key] = lines();
  try {
    sessionStorage.setItem(KEPT, JSON.stringify(all));
  } catch {
    // storage refused: the drafts stay in memory only
  }
}

// Back from the round trip: the kept drafts are the boxes' again, once.
try {
  const kept = JSON.parse(sessionStorage.getItem(KEPT) ?? 'null') as Record<string, Line[]> | null;
  sessionStorage.removeItem(KEPT);
  for (const [key, lines] of Object.entries(kept ?? {})) drafts.set(key, { lines });
} catch {
  // nothing kept
}
